import Sidebar from './Sidebar';
import SearchCommand from '../SearchCommand';
import SpecterAssistant from '../SpecterAssistant';

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-background" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 overflow-y-auto min-w-0">
        <div className="max-w-5xl mx-auto w-full px-8 py-8 md:px-12">
          {children}
        </div>
      </main>
      <SearchCommand />
      <SpecterAssistant suggestedPrompts={['What can you help me with?', 'Summarize my projects', 'Find a collaborator']} />
    </div>
  );
}
